document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.custom-faq-section');

  sections.forEach(function (section) {
    var triggers = section.querySelectorAll('.custom-faq-item__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // Nur die geklickte Frage innerhalb ihres eigenen Accordion-Blocks umschalten.
        // Andere offene Items im selben Block werden geschlossen (klassisches FAQ-Verhalten).
        var parentAccordion = trigger.closest('.custom-faq-accordion');
        if (parentAccordion) {
          var openTriggers = parentAccordion.querySelectorAll('.custom-faq-item__trigger[aria-expanded="true"]');
          openTriggers.forEach(function (openTrigger) {
            if (openTrigger !== trigger) {
              openTrigger.setAttribute('aria-expanded', 'false');
            }
          });
        }

        trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      });
    });
  });
});
